<template>

  <!--라우터 링크 설정
    :to 에는 router.js에 등록한 컴포넌트 name 또는 path 설정
    설정을 추가하면 url 또는 화면명으로 자동 active 해줌
    ex ) 
    <router-link 
      :to="item.link"
     
    >
      화면 이름
    </router-link>
  
  -->


  <header>
    <div class="container d-flex justify-content-between top-wrap">
      <router-link :to="{ name: 'index' }" class="home" :style="isTestServer() ? {width : '120px'}: ''">
        <span class="blind">홈</span>
      </router-link>
      
      <div v-if="isTestServer()">
        <span style="color: red;font-weight: bold;">TEST SERVER</span>
      </div>

      <nav class="nav-util">
        <!-- <span>{{ userStore.user?.userNm || '' }}</span> -->
        
        <a class="nav-util-admin"><span>{{ userStore.user?.userNm || '' }}</span></a>
       
        <div class="vr"></div>
        <a href="#" class="nav-util-capture" @click="capture"><span class="blind">캡쳐</span></a>

        <div class="vr"></div>
        <router-link v-if="myAlarmBellStore.NotReadMyAlarmCount > 0" v-badge.danger="myAlarmBellStore.NotReadMyAlarmCount " :to="{ name: 'MMP_AM_002' }" class="nav-util-alarm my-custom-badge-size" title="알람">
          <!-- <span :class="alarmActive">알람</span> -->
        </router-link>
        <router-link v-else :to="{ name: 'MMP_AM_002' }" class="nav-util-alarm" title="알람">
          <!-- <span :class="alarmActive">알람</span> -->
        </router-link>

        <div class="vr"></div>
        <router-link :to="{ name: 'MMP_AM_001' }" class="nav-util-my" title="MyPage">
          <span class="blind">마이페이지</span>
        </router-link>

        <div class="vr"></div>
        <a v-if="checkAuth" href="#" @click="moveToAdmin()" class="nav-util-set" title="설정" ><span class="blind">설정</span></a>
        <!-- <router-link :to="{ name: 'MCF_SC_001' }" class="nav-util-set" >
          
        </router-link> -->

        <div class="vr"></div>
        <a class="nav-util-out" @click="logout()" title="로그아웃"><span class="blind">로그아웃</span></a>
      </nav>
      <ElButton type="hamburgerM" target="offcanvasTop">
        <span class="nav-m-allmenu-icon"></span>
      </ElButton>
    </div>

    <!-- <div class="conainers-fluid nav-top">
      <div class="container d-flex p-0">
        <ElButton type="hamburger" target="offcanvasTop">
          <span class="nav-top-allmenu-icon"></span>
        </ElButton>
        <nav class="ms-5">
          <router-link v-for="item in state.gnb" :key="item.category" :to="item.link" :class="{ active: item.active }">
            {{ item.name }}
          </router-link>
        </nav>
      </div>
    </div> -->

    
    <div class="conainers-fluid nav-top">
      <div class="container d-flex p-0">
        <button class="nav-top-allmenu" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop">
          <span class="nav-top-allmenu-icon"></span>
        </button>
        <nav class="w-100 d-flex justify-content-between">
          <div class="btn-group flex-fill">
            <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">영업기회</a>
            <ul class="dropdown-menu">
              <template v-for="item in state.srLnb" :key="item.link">
                <li v-if="item.access">
                  <router-link :to="item.link" class="dropdown-item">
                      {{ item.name }}
                    </router-link>
                  </li>
              </template>
            </ul>
          </div>
          <div class="btn-group flex-fill">
            <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">영업기회관리</a>
            <ul class="dropdown-menu">
              <template v-for="(depth1,index1) in state.sm1Lnb" :key="depth1.key" >
                <template v-if="depth1.access">
                  <li>
                    <span class="dropdown-title">{{ depth1.name }}</span>
                    <ul class="dropdown-submenu">
                      <template v-for="item in state.sm2Lnb" :key="item.link">
                        <li v-if="item.access && depth1.key == item.key">
                          <router-link :to="item.link" class="dropdown-item">
                              {{ item.name }}
                          </router-link>
                        </li>
                      </template>
                    </ul>
                  </li>
                <li v-if="index1 !== (state.sm1Lnb.length-1)"><hr class="dropdown-divider"></li>
                </template>
              </template>
            </ul>
          </div>
          <div class="btn-group flex-fill">
            <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">회사</a>
            <ul class="dropdown-menu">
              <template v-for="(depth1,index1) in state.cp1Lnb" :key="depth1.key" >
                <template v-if="depth1.access">
                  <li>
                    <span class="dropdown-title">{{ depth1.name }}</span>
                    <ul class="dropdown-submenu">
                      <template v-for="item in state.cp2Lnb" :key="item.link">
                        <li v-if="item.access && depth1.key == item.key">
                          <router-link :to="item.link" class="dropdown-item">
                              {{ item.name }}
                          </router-link>
                        </li>
                      </template>
                    </ul>
                  </li>
                  <li v-if="index1 !== (state.cp1Lnb.length-1)"><hr class="dropdown-divider"></li>
                </template>
              </template>
            </ul>
          </div>
          <div class="btn-group flex-fill">
            <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">담당자</a>
            <ul class="dropdown-menu">
              <template v-for="item in state.shLnb" :key="item.link">
                <li v-if="item.access">
                  <router-link :to="item.link" class="dropdown-item">
                      {{ item.name }}
                    </router-link>
                  </li>
              </template>
            </ul>
          </div>
          <div class="btn-group flex-fill" v-if="authUser.isView">
            <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">상품</a>
            <ul class="dropdown-menu">
              <template v-for="item in state.imLnb" :key="item.link">
                <li v-if="item.access">
                  <router-link :to="item.link" class="dropdown-item">
                      {{ item.name }}
                    </router-link>
                  </li>
              </template>
            </ul>
          </div>
          <div class="btn-group flex-fill" v-if="authUser.isView">
            <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">리포트&대시보드</a>
            <ul class="dropdown-menu">
              <template v-for="(depth1,index1) in state.rd1Lnb" :key="depth1.key" >
                <template v-if="depth1.access">
                  <li>
                    <span class="dropdown-title">{{ depth1.name }}</span>
                    <ul class="dropdown-submenu">
                      <template v-for="item in state.rd2Lnb" :key="item.link">
                        <li v-if="item.access && depth1.key == item.key">
                          <router-link :to="item.link" class="dropdown-item">
                              {{ item.name }}
                          </router-link>
                        </li>
                      </template>
                    </ul>
                  </li>
                </template>
                <li v-if="index1 !== (state.rd1Lnb.length-1)"><hr class="dropdown-divider"></li>
              </template>
            </ul>
          </div>
        </nav>
      </div>
    </div>
   


    <div class="offcanvas offcanvas-top" tabindex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel">
      <div class="offcanvas-header-m">
        <div class="d-flex justify-content-between p-3">
          <div class="logo-m"></div>
          <ElButton type="headerClose"></ElButton>
        </div>
        <div class="d-flex justify-content-end">
          <nav class="nav-util-m">
            <a href="#" class="nav-util-capture"><span class="blind">캡쳐</span></a>

            <div class="vr"></div>
            <router-link :to="{ name: 'MMP_AM_002' }" class="nav-util-alarm-m">
              <span class='nav-util-news'>알람</span>
            </router-link>

            <div class="vr"></div>
            <router-link :to="{ name: 'MMP_AM_001' }" class="nav-util-my-m">
              <span class="blind">마이페이지</span>
            </router-link>

            <div class="vr"></div>
            <!-- <router-link :to="{ name: 'MCF_SC_001' }" class="nav-util-set-m" >
              <span class="blind">설정</span>
            </router-link> -->
            <a v-if="checkAuth" href="#" @click="moveToAdmin()" class="nav-util-set" ><span class="blind">설정</span></a>
            <a class="nav-util-out-m" @click="logout()"><span class="blind">로그아웃</span></a>
          </nav>
        </div>
        <div class="offcanvas-header-pttn"></div>
      </div>
      <div class="offcanvas-body">

        <div class="container">
          <div class="row">
            <div class="col-lg-2 px-0">
              <h3 class="allmenu-d01">
                <span class="allmenu-icon-01">영업기회 등록관리</span>
              </h3>
              <ul class="allmenu-d02">
                <template v-for="item in state.srLnb" :key="item.link">
                  <li data-bs-dismiss="offcanvas" v-if="item.access">
                    <router-link :to="item.link">
                      {{ item.name }}
                    </router-link>
                  </li>
                </template>

              </ul>
            </div>
            <div class="col-lg-2 px-0">
              <h3 class="allmenu-d01">
                <span class="allmenu-icon-01">영업기회 관리</span>
              </h3>
              <ul class="allmenu-d02">

                <template v-for="depth1 in state.sm1Lnb" :key="depth1.key" >
                  <template v-if="depth1.access">

                    <li>
                      <a href="#">{{ depth1.name }}</a>
                      <ul class="allmenu-d03">
                        
                        <template v-for="item in state.sm2Lnb" :key="item.link">
                          <li data-bs-dismiss="offcanvas" v-if="item.access && depth1.key == item.key">
                            <router-link :to="item.link">
                              {{ item.name }}
                            </router-link>
                          </li>
                        </template>
                      </ul>
                    </li>
                  </template>
                </template> 

              </ul>
            </div>

            <div class="col-lg-2 px-0">
              <h3 class="allmenu-d01">
                <span class="allmenu-icon-03">회사</span>
              </h3>
              <ul class="allmenu-d02">
                <template v-for="depth1 in state.cp1Lnb" :key="depth1.key" >
                  <template v-if="depth1.access">

                    <li>
                      <a href="#">{{ depth1.name }}</a>
                      <ul class="allmenu-d03">
                        
                        <template v-for="item in state.cp2Lnb" :key="item.link">
                          <li data-bs-dismiss="offcanvas" v-if="item.access && depth1.key == item.key">
                            <router-link :to="item.link">
                              {{ item.name }}
                            </router-link>
                          </li>
                        </template>
                      </ul>
                    </li>
                  </template>
                </template> 
              </ul>
            </div>

            <div class="col-lg-2 px-0">
              <h3 class="allmenu-d01">
                <span class="allmenu-icon-04">담당자</span>
              </h3>
              <ul class="allmenu-d02">
                <template v-for="item in state.shLnb" :key="item.link">
                  <li v-if="item.access" data-bs-dismiss="offcanvas">
                    <router-link :to="item.link">
                      {{ item.name }}
                    </router-link>
                  </li>
                </template>
              </ul>
            </div>

            <div class="col-lg-2 px-0" v-if="authUser.isView">
              <h3 class="allmenu-d01">
                <span class="allmenu-icon-05">상품</span>
              </h3>
              <ul class="allmenu-d02">
                <template v-for="item in state.imLnb" :key="item.link">
                  <li v-if="item.access" data-bs-dismiss="offcanvas">
                    <router-link :to="item.link">
                      {{ item.name }}
                    </router-link>
                  </li>
                </template>
              </ul>
            </div>

            <div class="col-lg-2 px-0" v-if="authUser.isView">
              <h3 class="allmenu-d01">
                <span class="allmenu-icon-06">리포트&대쉬보드</span>
              </h3>
              <ul class="allmenu-d02">
                <template v-for="depth1 in state.rd1Lnb" :key="depth1.key" >
                  <template v-if="depth1.access">

                    <li>
                      <a href="#">{{ depth1.name }}</a>
                      <ul class="allmenu-d03">
                        
                        <template v-for="item in state.rd2Lnb" :key="item.link">
                          <li data-bs-dismiss="offcanvas" v-if="item.access && depth1.key == item.key">
                            <router-link :to="item.link">
                              {{ item.name }}
                            </router-link>
                          </li>
                        </template>
                      </ul>
                    </li>
                  </template>
                </template> 
              </ul>
            </div>


          </div>
        </div>

      </div><!-- //offcanvas-body -->
      <div class="text-end p-3">
        <ElButton type="headerClose"></ElButton>
      </div>
    </div>

  </header>
  <Teleport to="body">
    <div v-show="alertBlur" class="blur"></div>
  </Teleport>
  <Vidle v-show="isNotvis" @idle="onIdle" :duration ="1800"></Vidle>
</template>

<script setup>
import { router } from '@/router';
import { ref, computed, onBeforeMount, watch, onBeforeUnmount, reactive } from 'vue'
import { useRoute } from "vue-router";
import { useUserStore } from '@/store/user';
import { useMyAlarmStore } from '@/store/myalarm';
import { menuList } from '@/api/menu';

import { capture } from '@/js/capture';
import { useLoading } from '@/composable/Loading.js'
import { useMultipleIdleEvents } from '@/js/idle.js';
import Vidle from 'v-idle'
import Avatar from 'primevue/avatar';

const isNotvis = ref(false)
const isIdle = ref(false);
const alertBlur = ref(false)
const { setIsLoading } = useLoading()

const route = useRoute()
const userStore = useUserStore()
const myAlarmBellStore = useMyAlarmStore()
const checkAuth = computed(()=>{
  let canAccess = false

  if(!userStore.user) return canAccess

  cfMenuId.value.some((menu)=>{
    if(userStore.user.mnUrl.includes(menu.menuId)){
      canAccess = true
      return true
    }
  })
  return canAccess
})

const alarmActive = computed(()=>{
  return myAlarmBellStore.NotReadMyAlarm ? 'nav-util-news' : 'blind'
})

const state = computed(() => {
  const data = {
    msg: 'Header 컴포넌트',
    gnb: [
      { name: '영업기회 등록관리', link: '', category: 'sr', active: false },
      { name: '영업기회관리', link: '', category: 'sm', active: false },
      { name: '회사', link: '', category: 'cp', active: false },
      { name: '담당자', link: '', category: 'sh', active: false },
      { name: '상품', link: '', category: 'im', active: false },
      { name: '리포트&대쉬보드', link: '', category: 'rd', active: false },
    ],
    //영업기회 등록 lnb
    srLnb: [
      { name: '영업기회 등록/수정', link: '/sr/MSR_SO_001', id: 'M001M001', access: false },       // PO 조회 팝업 	              PPT_PO_001
      { name: '영업기회 조회', link: '/sr/MSR_SO_002', id: 'M001M002', access: false },  // 영업기회 ID, 매출처 조회 팝업 	PPT_SO_002
    ],

    //영업기회 관리 lnb
    sm1Lnb :[
        {key : 'sa1',name:'영업기회 알람기능', link :'',id:'M002M001',access:false},
        {key : 'sa2',name:'리드 관리', link :'',id:'M002M002',access:false},
        {key : 'sa3',name:'이벤트 관리', link :'',id:'M002M003',access:false},

    ],
    sm2Lnb : [
        {key : 'sa1',name:'영업기회 알람 등록/수정',        link : '/sm/MSM_SA_001' ,id:'M002M001M001',access:false},
         {key : 'sa1',name:'영업기회 알람 조회',  link : '/sm/MSM_SA_002' ,id:'M002M001M002',access:false},
    
        {key : 'sa2',name:'리드 등록/수정',                link : '/sm/MSM_SA_004' ,id:'M002M002M001',access:false},
        {key : 'sa2',name:'리드 조회',          link : '/sm/MSM_SA_005' ,id:'M002M002M002',access:false},
          
        {key : 'sa3',name:'이벤트 등록/수정',            link : '/sm/MSM_SA_007' ,id:'M002M003M001',access:false},
        {key : 'sa3',name:'이벤트 조회',       link : '/sm/MSM_SA_008' ,id:'M002M003M002',access:false},
    ],

    //회사 lnb
    cp1Lnb :[
        {key : 'cp1',name:'회사분류기준관리',link:'',id:'M003M001',access:false},
        {key : 'cp2',name:'회사 등록관리',link:'',id:'M003M002',access:false},
    ],
    cp2Lnb : [
        {key : 'cp1',name:'회사 분류체계 등록/수정',link : '/cp/MCP_CL_002',id:'M003M001M001',access:false},
        {key : 'cp1',name:'회사 분류체계 조회',link : '/cp/MCP_CL_004',id:'M003M001M003',access:false},
        {key : 'cp1',name:'회사 분류체계 이력 조회',link : '/cp/MCP_CL_003',id:'M003M001M002',access:false},
        
        {key : 'cp2',name:'회사 등록/수정', link : '/cp/MCP_CR_001',id:'M003M002M001',access:false},
        {key : 'cp2',name:'회사 조회',link : '/cp/MCP_CR_002',id:'M003M002M002',access:false},
    ],

    //담당자 lnb/담당자 등록관리
    shLnb: [
      { name: '담당자 등록/수정', link: '/sh/MSH_SR_001', id: 'M004M001', access: false },
      { name: '담당자 조회', link: '/sh/MSH_SR_002', id: 'M004M002', access: false },
    ],

    //상품 lnb/상품분류기준 관리
    imLnb: [
      { name: '상품 분류체계 등록/수정', link: '/im/MIM_CL_001', id: 'M005M001', access: false },
      { name: '상품 분류체계 조회', link: '/im/MIM_CL_003', id: 'M005M003', access: false },
      { name: '상품 분류체계 이력 조회', link: '/im/MIM_CL_002', id: 'M005M002', access: false },
      { name: '상품 분류체계 맵핑 화면', link: '/im/MIM_CL_004', id: 'M005M004', access: false },
      { name: '상품버전 회계연도매핑', link: '/im/MIM_CL_005', id: 'M005M005', access: false },
      { name: '영업기회 상품정보 일괄수정', link: '/im/MIM_CL_006', id: 'M005M006', access: false },
    ],

    //리포트|대쉬보드 lnb
    rd1Lnb :[
        {key : 'im1',name:'리포트',link:'',id: 'M006M001', access : false},
        {key : 'im2',name:'대시보드',link:'',id: 'M006M002', access : false},
    ],
    rd2Lnb : [
        {key : 'im1',name:'Yearly Performance FCST',link : '/rd/MRD_RT_001',id: 'M006M001M001', access : false},
        {key : 'im1',name:'Yearly Cashflow FCST',link : '/rd/MRD_RT_002',id: 'M006M001M002', access : false},
        {key : 'im1',name:'Monthly Revenue & Gross Margin', link : '/rd/MRD_RT_003',id: 'M006M001M003', access : false},
        {key : 'im1',name:'Pipeline Hygiene',link : '/rd/MRD_RT_004',id: 'M006M001M004', access : false},
        {key : 'im1',name:'Payment',  link : '/rd/MRD_RT_005',id: 'M006M001M005', access : false},

        {key : 'im2',name:'대시보드',  link : '/rd/MRD_DS_002',id: 'M006M002M002', access : false},
    ],
    //공통
    coLnb: [
      { name: '엑셀 Upload / Download', link: '/co/MCO_EX_001', access: false },
    ],
    midLnb : [
      { name: '영업기회 알람기능', id: 'M002M001', access: false },
      { name: '리드 관리', id: 'M002M002', access: false },
      { name: '이벤트 관리', id: 'M002M003', access: false },
      { name: '회사 분류기준 관리', id: 'M003M001', access: false },
      { name: '회사 등록관리', id: 'M003M002', access: false },
      { name: '리포트', id: 'M006M001', access: false },
      { name: '대쉬보드', id: 'M006M002', access: false },
    ]
  }

  let activeCategory
  Object.values(data).forEach(datum => {
    Object.values(datum).forEach(item => {
      if (item.link === route.path) {
        const [, category] = route.path.split('/')
        activeCategory = category
      }
    })
  })

  data.gnb.forEach(item => {
    item.active = item.category === activeCategory
  })

  const lnbList = Object.keys(data).filter(name => name.includes('Lnb'))
  lnbList.forEach(lnb => {
    data[lnb].forEach(item => {
      if (userStore.user) {
        item.access = item.id ? userStore.user.mnUrl.includes(item.id) : true
      }
    })
  })
  return data

})

const authUser = reactive({
  isView : true
})


// 로그아웃 로직 추가
const onIdle = () => {
  alertBlur.value=true
  userStore.setUser(null);
  setTimeout(() => {
    alert('30분 동안 동작이 없어 로그아웃 되었습니다.');
    location.href = '/login'
  }, 100); // 100ms 지연
};






// // 30분 동작 없을시 로그아웃
// const count = ref(0)
// const timer = ref()
// const alertBlur = ref(false)
// function checkMove() {
//   if (timer.value) {
//     clearInterval(timer.value);
//     timer.value = null;
//     count.value = 0;
//   }
//   if(timer.value == null){
//     timer.value = setInterval(() => {
//     count.value++
//     console.log(count.value,'초')
//     if (count.value >= 1800) {
//       setIsLoading(true)
//       alertBlur.value = true
//       count.value = 0
//       userStore.setUser(null)
//       clearInterval(timer.value)
      
//       setTimeout(() => {
//         alert('30분 동안 동작이 없어 로그아웃 되었습니다. 다시 로그인 해 주세요.')
//         setIsLoading(false)
//         location.href = '/login'
//       })
      
//       }
//     }, 1000)
//   }
    
 
  // if (timer.value) {
  //   clearInterval(timer.value)
  //   count.value = 0
  // }
 
// }

const checkEventTypeList = ['mousemove', 'keydown', 'click','load']
onBeforeMount(async () => {
  // checkMove();
  // checkEventTypeList.forEach(type => {
  //   window.addEventListener(type, checkMove)
  // })
  
  if(userStore.user){
    getMyAlarmList()
    getMenuList()
    //임시: 일반유저 상품,대시보드 안보이게
    if(userStore.user.authGrpId == 'U'){
      authUser.isView = false
    }
  } 

})
const cfMenuId = ref([])
async function getMenuList(){
  try{
    const res = await menuList()
    cfMenuId.value = [...res.rtn].map((item)=>{
      if(item.menu_url.includes('/cf')){
        return {menuId : item.menu_id , link : item.menu_url}
      }
    }).filter((menu)=>menu)
  }catch(e){
    console.log(e)
  }
}
async function getMyAlarmList(){
  try{ 
    await myAlarmBellStore.myAlarmListData()
  }catch(error){
    console.log(error)
  }
}

// const getDataList =  computed(() => {
//   return NotReadMyAlarmBell.value ? 'nav-util-news' : 'blind'
// })   

// watch(NotReadMyAlarmBell, () => {
//   console.log('NotReadMyAlarm 값이 변경되어 getDataList 다시 계산됨');
//   getDataList.value; // 변경된 값을 사용할 수 있음
// });

onBeforeUnmount(async () => {
  // clearInterval(timer.value)
  // checkEventTypeList.forEach(type => {
  //   window.removeEventListener(type, checkMove)
  // })

  
})

const logout = () => {
  if (confirm('로그아웃하시겠습니까?')) {
    userStore.setUser(null)
    router.push({ path: '/login' })
  }
}



function moveToAdmin(){
  let menuLink = ''
  cfMenuId.value.some((menu)=>{
    if(userStore.user.mnUrl.includes(menu.menuId)){
      menuLink = menu.link
      return true
    }
  })

  router.push({path:menuLink})
}

function isTestServer(){
  if(process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PHASE == 'MKt'){
    return true
  }
  return false
}
</script>

<style scoped>
/*gnb active*/
.nav-top nav a.active {
  color: #e0e2f1;
  text-decoration: underline;
}

.my-custom-badge-size :deep(.p-badge) {
  font-size: 0.65rem;
  padding: 0.6rem 0.3rem;
  min-width: 1.9em;
  height: 1.2em;
  line-height: 1.2em;
  border-radius: 50%;
  top: 0.7em;
  right: 0.7em;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.blur {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(8px);
  z-index: 999;
}
</style>